export function CommissionPolicyService($http, apexApiUrl) {
    'ngInject'
    const service = {
        // Data:
        retrieveCommissionPolicies: retrieveCommissionPolicies,
        retrieveCommissionPolicy: retrieveCommissionPolicy,
        retrieveCommissionPermissions: retrieveCommissionPermissions,
        createCommissionPolicy: createCommissionPolicy,
        updateCommissionPolicy: updateCommissionPolicy,
        deleteCommissionPolicy: deleteCommissionPolicy,

        // Logic:
        duplicateCommissionPolicyExists: duplicateCommissionPolicyExists
    };

    return service;

    function retrieveCommissionPolicies(icdCorporationID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "corporations/" + icdCorporationID + "/commission-policies",
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function retrieveCommissionPermissions(icdCorporationID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "corporations/" + icdCorporationID + "/commission-permissions",
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function retrieveCommissionPolicy(commissionPolicyID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "commission-policies/" + commissionPolicyID,
            headers: {
                Accept: "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    function createCommissionPolicy(commissionPolicy) {
        const requestModel = {
            IcdCorporationID: commissionPolicy.IcdCorporationID,
            ProgramID: commissionPolicy.ProgramID,
            RetailerID: commissionPolicy.RetailerID,
            Archives: createArchiveDTO(commissionPolicy.Archives)
        };

        return $http({
            method: "POST",
            url: apexApiUrl + "commission-policies",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: requestModel
        }).then(function (response) {
            return response.data;
        });
    }

    function updateCommissionPolicy(commissionPolicyID, commissionPolicy) {
        const archives = commissionPolicy.Archives.filter(function (archive) {
            return !archive.IsDeleted || !archive.IsNew;
        });
        const requestModel = {
            Archives: createArchiveDTO(archives)
        };

        return $http({
            method: "PUT",
            url: apexApiUrl + "commission-policies/" + commissionPolicyID,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: requestModel
        }).then(function (response) {
            return retrieveCommissionPolicy(commissionPolicyID);
        });
    }

    function deleteCommissionPolicy(commissionPolicyID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "commission-policies/" + commissionPolicyID
        }).then(function (response) {
            return response.data;
        });
    }


    /**
         * Return whether any commission policy already exists in the given list of commission
         * policies with the same program and retailer as the given policy.
         * @param commissionPolicy The CommissionPolicy being checked.
         * @param commissionPolicies The list of CommissionPolicies.
         * @returns whether there are any duplicates.
         */
    function duplicateCommissionPolicyExists(commissionPolicy, commissionPolicies) {
        let anyDuplicates = false;
        if (commissionPolicy.Program && commissionPolicy.Retailer) {
            anyDuplicates = commissionPolicies.reduce(function (any, other) {
                return any || other !== commissionPolicy
                    && other.Program && other.Program.Id === commissionPolicy.Program.Id
                    && other.Retailer && other.Retailer.Id === commissionPolicy.Retailer.Id;
            }, false);
        }
        return anyDuplicates;
    }

    function createArchiveDTO(archives) {
        return archives.map(function (archive) {
            return {
                IsNew: archive.IsNew,
                IsDeleted: archive.IsDeleted,
                CommissionPolicyArchiveID: archive.Id,
                ActiveStart: archive.ActiveStart ? kendo.format("{0:yyyy-MM-dd}", archive.ActiveStart) : null,
                ActiveEnd: archive.ActiveEnd ? kendo.format("{0:yyyy-MM-dd}", archive.ActiveEnd) : null,
                Tiers: archive.Tiers.map(function (tier) {
                    return {
                        IsNew: !!tier.IsNew,
                        IsDeleted: !!tier.IsDeleted,
                        CommissionPolicyTierID: tier.Id,
                        StartAmount: tier.StartAmount,
                        EndAmount: tier.EndAmount,
                        TierRate: tier.TierRate,
                        DailyNCRThreshold: tier.DailyNCRThreshold,
                        DailyDollarGuaranteeAmt: tier.DailyDollarGuaranteeAmt
                    }
                })
            };
        })
    }
}
